// Import necessary modules and utilities
import axios from "axios";
import { LocalStorage } from "../utils";
import { baseUrl } from "../Environments/environment";
import { toast } from "react-toastify";

// Create an Axios instance for API requests
const apiClient = axios.create({
	baseURL: baseUrl, // Set the base URL for API requests
	withCredentials: true, // Include credentials (cookies) with requests
	timeout: 120000, // Set request timeout to 2 minutes
});

// Interceptor to set authorization header with user token before making requests
apiClient.interceptors.request.use(
	function (config) {
		// Retrieve user token from local storage
		const token = LocalStorage.get("accessToken");
		// Set authorization header with bearer token for authentication
		config.headers.Authorization = `Bearer ${token}`;
		return config;
	},
	function (error) {
		return Promise.reject(error); // Reject the request if an error occurs
	}
);

// Add a response interceptor
apiClient.interceptors.response.use(
	(response) => response, // Pass successful responses
	async (error) => {
		if (error.response && error.response.data.message === "TokenExpiredError") {
			// Access token has expired
			try {
				// Attempt to get a new access token
				const response = await axios.post(
					`${baseUrl}/auth/refresh-token`,
					{},
					{
						withCredentials: true,
					}
				);
				// Save the new access token

				const newAccessToken = response.data.result.accessToken;

				LocalStorage.set("accessToken", newAccessToken); // Save the new access token in local storage

				// Retry the original request with the new token
				error.config.headers.Authorization = `Bearer ${newAccessToken}`;

				// again make a new request with the new access token
				if (!error.config._retry) {
					error.config._retry = true; // Mark the request as retried
					return apiClient.request(error.config);
				}
			} catch (refreshError) {
				// If refresh token fails, redirect to login
				console.error("Refresh token failed", refreshError);
				LocalStorage.clear();
				window.location.href = "/";
			}
		}
		if (error.response && error.response.data.message === "InvalidToken") {
			LocalStorage.clear();
			window.location.href = "/";
			toast.error("Please log in again.");
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}
);

// API function to log in a user
const loginUser = (data) => {
	return apiClient.post("/user/login", data);
};

// API function to log out the user
const logoutUser = () => {
	return apiClient.post("/user/logout");
};
const postGoogleAuth = (body) => {
	return apiClient.post("/user/google-sign-in", body);
}

// Export the API functions
export { loginUser, logoutUser, postGoogleAuth,apiClient };
